import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../components/Table";
import { fetchReviews, selectReviews } from "../store/slices/avisSlice";

function ListAvis() {
  const dispatch = useDispatch();

  // Sélecteurs
  const reviews = useSelector(selectReviews);
  const { user } = useSelector((state) => state.user);
  const idEtablissement = user?.etablissement?.id;

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (idEtablissement) {
      dispatch(fetchReviews({ idEtablissement, page: currentPage }));
    }
  }, [dispatch, idEtablissement, currentPage]);

  const columns = [
    { Header: "Date de réservation", accessor: "dateReservation" },
    { Header: "Prestation", accessor: "prestation" },
    { Header: "Client", accessor: "client" },
    { Header: "Note", accessor: "note" },
    { Header: "Commentaire", accessor: "comment" },
  ];

  const data = useMemo(() => {
    return reviews?.map((review) => ({
      id: review?.id,
      dateReservation: review?.appointment?.start_time
        ? new Date(review.appointment.start_time).toLocaleDateString()
        : "",
      heureReservation: review?.appointment?.start_time
        ? review?.appointment?.start_time
        : "",
      prestation: review?.appointment?.prestations_snapshot[0]?.name || "",
      client: `${review?.user?.prenom || ""} ${review?.user?.nom || ""} `,
      note: review?.rating ? `${review.rating}/5` : "",
      comment: review?.comment || "",
    }));
  }, [reviews]);


  return (
    <>
      <Table columns={columns} data={data} paginationDisabled="paginationDisabled" />
    </>
  );
}

export default ListAvis;
